import { HiringCityDto } from "./hiringCity.dto";
import { IdentifiableDto } from "./identifiable.dto";

export class MatchedLeadsProductHiringCityDto extends IdentifiableDto {
    city: HiringCityDto;
    radius: number;
}